var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileFailedXs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.99829 2.26493C2.99829 1.6206 3.52063 1.09827 4.16496 1.09827H11.165C11.3067 1.09827 11.4418 1.15843 11.5366 1.26378L14.5366 4.59712C14.6192 4.68893 14.665 4.80808 14.665 4.9316V7.9316C14.665 8.20774 14.4411 8.4316 14.165 8.4316C13.8888 8.4316 13.665 8.20774 13.665 7.9316V5.12347L10.9423 2.09827H4.16496C4.07291 2.09827 3.99829 2.17289 3.99829 2.26493V14.2649C3.99829 14.357 4.07291 14.4316 4.16496 14.4316H8.16496C8.4411 14.4316 8.66496 14.6555 8.66496 14.9316C8.66496 15.2077 8.4411 15.4316 8.16496 15.4316H4.16496C3.52063 15.4316 2.99829 14.9093 2.99829 14.2649V2.26493Z",
    fill: "#2D2943"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1447 9.91138C10.34 9.71612 10.6566 9.71612 10.8518 9.91138L14.8518 13.9114C15.0471 14.1066 15.0471 14.4232 14.8518 14.6185C14.6566 14.8137 14.34 14.8137 14.1447 14.6185L10.1447 10.6185C9.94948 10.4232 9.94948 10.1066 10.1447 9.91138Z",
    fill: "#2D2943"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8518 9.91138C15.0471 10.1066 15.0471 10.4232 14.8518 10.6185L10.8518 14.6185C10.6566 14.8137 10.34 14.8137 10.1447 14.6185C9.94948 14.4232 9.94948 14.1066 10.1447 13.9114L14.1447 9.91138C14.34 9.71612 14.6566 9.71612 14.8518 9.91138Z",
    fill: "#2D2943"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8316 1.09827C11.1078 1.09827 11.3316 1.32212 11.3316 1.59827V4.4316H14.165C14.4411 4.4316 14.665 4.65546 14.665 4.9316C14.665 5.20774 14.4411 5.4316 14.165 5.4316H10.8316C10.5555 5.4316 10.3316 5.20774 10.3316 4.9316V1.59827C10.3316 1.32212 10.5555 1.09827 10.8316 1.09827Z",
    fill: "#2D2943"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileFailedXs);
export default __webpack_public_path__ + "static/media/file-failed-xs.4406e04f.svg";
export { ForwardRef as ReactComponent };